module.exports = __webpack_public_path__ + "img/sv22.dfa0bc40.svg";